exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{box-sizing:border-box}body{margin:0;padding:0}.popover,body{font-family:Red Hat Text,sans-serif}", ""]);

// exports
